import { Injectable } from '@angular/core';
import {
  ResourceAction,
  ResourceCRUD,
  ResourceMethod,
  ResourceParams
} from 'ng2-resource-rest';
import { RequestMethod } from '@angular/http';
import { DateString } from './types';
import * as moment from 'moment';

export interface IBalanceInput {
  receipt?: number;
  who     : string;
  date    : DateString|Date;
  amount  : number;
  what    : string;
}

export interface IBalance extends IBalanceInput{
  id      : number;
}

@Injectable()
@ResourceParams({
  url: '/api/balance'
})
export class Balance extends ResourceCRUD<IBalanceInput, IBalance, IBalance> {

  public static newBalance() : IBalance {
    return {
      id      : null,
      who     : '',
      date    : moment().toDate(),
      amount  : 0,
      what    : ''
    };
  }

  @ResourceAction({
    path: '/add',
    method: RequestMethod.Post
  })
  public add: ResourceMethod<IBalanceInput, IBalance>;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/balance.ts